import React from 'react';
import Navbar from '../components/Navbar';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              <strong>Effective Date:</strong> January 1, 2025
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 mb-6">
              By accessing and using MTClicks services, you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to abide by the above, please do 
              not use this service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Description of Service</h2>
            <p className="text-gray-600 mb-6">
              MTClicks provides digital marketing services including but not limited to search engine 
              optimization, social media marketing, content creation, and advertising management. We 
              reserve the right to modify or discontinue our services at any time.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. User Responsibilities</h2>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• Provide accurate and complete information when requested</li>
              <li>• Maintain the confidentiality of your account credentials</li>
              <li>• Use our services in compliance with all applicable laws</li>
              <li>• Not engage in any activity that could harm our systems or other users</li>
              <li>• Respect intellectual property rights of MTClicks and third parties</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Payment Terms</h2>
            <p className="text-gray-600 mb-4">
              Payment terms are specified in individual service agreements. Unless otherwise stated:
            </p>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• Payment is due within 30 days of invoice date</li>
              <li>• Late payments may incur additional charges</li>
              <li>• Refunds are subject to our refund policy</li>
              <li>• All prices are subject to change with 30 days notice</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Intellectual Property</h2>
            <p className="text-gray-600 mb-6">
              All content, trademarks, and intellectual property created by MTClicks remain our 
              property unless explicitly transferred to the client. Clients retain ownership of 
              their original content and data provided to us.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Privacy and Data Protection</h2>
            <p className="text-gray-600 mb-6">
              Your privacy is important to us. Please review our Privacy Policy to understand how 
              we collect, use, and protect your information. By using our services, you consent 
              to our data practices as described in our Privacy Policy.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-600 mb-6">
              MTClicks shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages, including but not limited to loss of profits, data, or other 
              intangible losses resulting from the use of our services.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Service Level Agreement</h2>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• We strive to maintain 99.9% uptime for our services</li>
              <li>• Support response times vary by service level</li>
              <li>• Scheduled maintenance will be communicated in advance</li>
              <li>• Emergency maintenance may occur without prior notice</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Termination</h2>
            <p className="text-gray-600 mb-6">
              Either party may terminate services with 30 days written notice. MTClicks reserves 
              the right to terminate services immediately for breach of these terms or non-payment.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Changes to Terms</h2>
            <p className="text-gray-600 mb-6">
              We reserve the right to modify these terms at any time. Changes will be effective 
              immediately upon posting. Continued use of our services constitutes acceptance of 
              the modified terms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Contact Information</h2>
            <div className="bg-gray-100 p-4 rounded-lg mb-6">
              <p className="text-gray-800 font-medium">MTClicks Legal Department</p>
              <p className="text-gray-600">Email: legal@mtclicks.com</p>
              <p className="text-gray-600">Phone: +1 (555) 123-4567</p>
              <p className="text-gray-600">Address: 123 Marketing Street, Digital City, DC 12345</p>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
              <p className="text-blue-800">
                <strong>Note:</strong> These terms constitute the entire agreement between you and 
                MTClicks regarding the use of our services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
